import { useState } from 'react';
import { useEffectOnce } from 'react-use';
import { IObservable } from '../utils';

export const useObservable = <T>(observable: IObservable<T>): T => {
	const [value, setValue] = useState(observable.getValue());

	useEffectOnce(() => {
		const sub = observable.subscribe((value) => {
			setValue(value);
		});

		return () => {
			sub.unsubscribe();
		};
	});

	return value;
};
